import React from 'react';
import { StashDeviationElementPlacement } from './types';
import { useStashElementPlacementMap } from './useStashElementPlacementMap';
export const StashElementPlacementContext = /*#__PURE__*/ React.createContext({
    elementGroups: {
        adoptableBuyer: {
            groupPlacement: StashDeviationElementPlacement.NotIncluded,
            countOnBar: 0
        },
        adoptableSeller: {
            groupPlacement: StashDeviationElementPlacement.NotIncluded,
            countOnBar: 0
        }
    },
    deleteDeviation: StashDeviationElementPlacement.NotIncluded,
    editDeviation: StashDeviationElementPlacement.NotIncluded,
    premiumDownload: StashDeviationElementPlacement.NotIncluded,
    freeDownload: StashDeviationElementPlacement.NotIncluded,
    sellDeviation: StashDeviationElementPlacement.NotIncluded,
    copyLink: StashDeviationElementPlacement.NotIncluded,
    muroImport: StashDeviationElementPlacement.NotIncluded,
    muroOpen: StashDeviationElementPlacement.NotIncluded,
    meta: {
        hasPrimaryMoreActionsMenu: false
    }
});
export const StashElementPlacementContextProvider = ({ deviation, children })=>{
    const elementPlacementMap = useStashElementPlacementMap(deviation);
    return /*#__PURE__*/ React.createElement(StashElementPlacementContext.Provider, {
        value: elementPlacementMap
    }, children);
};
StashElementPlacementContextProvider.displayName = 'StashElementPlacementContextProvider';

//# sourceMappingURL=context.js.map